<ng-container *ngIf="isInitialized">
  <ul *ngIf="items && items.length > 0" class="widget__list" style="margin-bottom: 15px;">
    <li
      *ngFor="let item of items | paginate: { id: url, itemsPerPage: pagination.pageSize, currentPage: p, totalItems: pagination.total }"
      class="widget__list__item">
      <span class="widget__list__title"
        [innerHtml]="dateFormat(item.datetime_from) + ' - ' + dateFormat(item.datetime_to) + ' (' + getTitle(item.appointment_calendar) + ')'"></span>
      <span class="widget__list__actions">
        <a [routerLink]="[(routePrefix ? routePrefix + '/' : '') + 'edit', item.id]"
          class="widget__list__actions__link widget__list__actions__link--edit">
          <i class="ico-edit"></i>
        </a>
        <a *ngIf="!item.is_default"
          [routerLink]="{ outlets: { 'modal': [(routePrefix ? routePrefix + '-' : '') + 'delete', item.id] } }"
          [queryParams]="{header:'Opravdu chcete smazat položku ' + dateFormat(item.datetime_from) + ' - ' + dateFormat(item.datetime_to) + '?', body: 'Položku již nebude možné obnovit.'}"
          class="widget__list__actions__link widget__list__actions__link--remove">
          <i class="ico-remove"></i>
        </a>
      </span>
    </li>
  </ul>
  <pagination-controls id="{{ url }}" (pageChange)="pageChanged($event)" maxSize="9" directionLinks="true"
    autoHide="true" previousLabel="" nextLabel="" screenReaderPaginationLabel="Pagination"
    screenReaderPageLabel="Stránka" screenReaderCurrentLabel="Jste na stránce"
    *ngIf="pagination.pageSize < pagination.total">
  </pagination-controls>
</ng-container>

<div *ngIf="!isInitialized" class="widget__content loading"></div>

<swb-no-data *ngIf="items && items.length === 0 && isInitialized"></swb-no-data>
